import type { SelectedItem } from '../SelectItems.types'

export const removeItemFromSelectedItems = (variantId: string, selectedItems: SelectedItem[]) =>
  selectedItems.filter((selectedItem) => selectedItem.variantId !== variantId)
